import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'

class CalendarVisibilityBadge extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            visibility: this.props.visibility || '',
            style: this.props.style || {},
        }
        this.className = this.props.className || ''
    }
    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            visibility: nextProps.visibility || '',
            style: nextProps.style || {},
        })
    }

    renderVisibility() {
        switch (this.state.visibility) {
            case 'public':
                return <div className="text-success text-with-icon">
                    <FormattedMessage
                        id="calendar.visibility.public"
                        defaultMessage="Public"
                    />
                </div>
            case 'private':
                return <div className="text-secondary text-with-icon">
                    <FormattedMessage
                        id="calendar.visibility.private"
                        defaultMessage="Private"
                    />
                </div>
            default: return <div className="text-success text-with-icon">
                <FormattedMessage
                    id="calendar.visibility.public"
                    defaultMessage="Public"
                />
            </div>
        }
    }

    render() {
        return <span className={this.className} style={this.state.style}>
            {this.renderVisibility()}
        </span>
    }

}

export default CalendarVisibilityBadge





// WEBPACK FOOTER //
// ./src/calendar/calendarvisibilitybadge.component.jsx